import React from "react";
import { Navigate } from "react-router-dom";

interface PrivateRouteProps {
  allowedRoles?: string[];
  requiredRole?: string;
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  allowedRoles,
  requiredRole,
  children,
}) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const role = localStorage.getItem("role");
  const roles = allowedRoles || (requiredRole ? [requiredRole] : []);

  if (!isLoggedIn || !role || !roles.includes(role)) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
